import React, { useEffect, useRef, useState } from "react";
import { TypeAnimation } from "react-type-animation";

import { motion, AnimatePresence } from "motion/react";

export function randomNumber(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const ImageShape = ({ className, variant, url, hide }) => {
  const floatingAnimation = {
    x: [0, randomNumber(4, 12), 0],
    y: [0, randomNumber(5, 9), 0], // Move up by 20px, then back to original
    transition: {
      duration: 10, // Duration of one cycle
      ease: "easeInOut",
      repeat: Infinity, // Loop indefinitely
    },
    exit: {
      y: "-150%",
    },
  };

  const shape = (function () {
    switch (variant) {
      case 1:
        return "artist-shape-1";
      case 2:
        return "artist-shape-2";
      case 3:
        return "artist-shape-3";
      default:
        return "artist-shape-4";
    }
  })();

  const badgeShape = (function () {
    switch (variant) {
      case 1:
        return "artist-shape-badge-1";
      case 2:
        return "artist-shape-badge-2";
      case 3:
        return "artist-shape-badge-3";
      default:
        return "artist-shape-badge-4";
    }
  })();

  const badgeName = (function () {
    switch (variant) {
      case 1:
        return require("../assets/img/shape-stats-1.svg");
      case 2:
        return null;
      case 3:
        return require("../assets/img/shape-stats-3.svg");
      default:
        return require("../assets/img/shape-stats-4.svg");
    }
  })();

  return (
    <AnimatePresence>
      {!hide && (
        <motion.div
          className={className}
          initial={{ opacity: 0, y: "100%" }}
          animate={{ opacity: 1, y: "0%" }}
          exit={{ opacity: 0, y: "-400%" }}
          transition={{
            duration: 1.0,
            delay: 0.5,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          <motion.img
            referrerPolicy="no-referrer"
            className={"artist-shape " + shape}
            src={url}
            animate={floatingAnimation}
          />
          <motion.img
            className={badgeShape}
            style={{
              right: 0,
              bottom: 0,
              position: "absolute",
            }}
            src={badgeName}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export const StatsIntroBackground = ({ data, hide }) => {
  return (
    <div className="app-stats-intro-background">
      {data && data.top_artists && data.top_artists[0] && (
        <ImageShape
          url={data.top_artists[0].artist_id.artwork}
          className="artist-shape-container artist-shape-container-1"
          variant={1}
          hide={hide}
        />
      )}

      {data && data.top_artists && data.top_artists[1] && (
        <ImageShape
          url={data.top_artists[1].artist_id.artwork}
          className="artist-shape-container artist-shape-container-2"
          variant={2}
          hide={hide}
        />
      )}

      {data && data.top_artists && data.top_artists[2] && (
        <ImageShape
          url={data.top_artists[2].artist_id.artwork}
          className="artist-shape-container artist-shape-container-3"
          variant={3}
          hide={hide}
        />
      )}

      {data && data.top_artists && data.top_artists[3] && (
        <ImageShape
          url={data.top_artists[3].artist_id.artwork}
          className="artist-shape-container artist-shape-container-4"
          variant={4}
          hide={hide}
        />
      )}
    </div>
  );
};

export const StatsIntro = ({ data, next }) => {
  const [hide, setHide] = useState(false);

  return (
    <motion.div className="app-stats-intro-content" key="step-0">
      <StatsIntroBackground data={data} hide={hide} />

      <div
        className="center-container"
        initial={{ opacity: 0, y: "100%" }}
        animate={{ opacity: 1, y: "0%" }}
        exit={{ opacity: 0, y: "-400%" }}
        transition={{
          duration: 1.0,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
      >
        <TypeAnimation
          className="stats-typer"
          sequence={[
            1000,
            "👋",
            1000,
            "We know", //  Continuing previous Text
            750,
            "We know, you love your stats",
            500,
            "Stats ✊",
            100,
            "Stats ✊ Stats ✊",
            100,
            () => {
              setHide(true);
            },
            "Stats ✊ Stats ✊ Stats ✊",
            1000,
            () => {
              next();
            },
          ]}
          style={{ fontSize: "2em" }}
          typeSpeed={420}
        />
      </div>
    </motion.div>
  );
};
